/** @format */

import { PlatformRmoCollectionInterface } from '../../interfaces/collections/PlatformRmoInterface';

export const StoreStackReducerAction = {
    LOAD_PLATFORM_RMO_MODEL_PARTNER_MVNE_LIST: 'LOAD_PLATFORM_RMO_MODEL_PARTNER_MVNE_LIST',
};

export interface StoreStackReducerType {
    type: string;
    platformRmoCollection?: PlatformRmoCollectionInterface;
}

export const storeStackReducer = (state: any, action: StoreStackReducerType): object => {
    switch (action.type) {
        case StoreStackReducerAction.LOAD_PLATFORM_RMO_MODEL_PARTNER_MVNE_LIST:
            if (state.platformRmoCollection) {
                return { ...state };
            }
            break;
        default:
            break;
    }
    return {
        ...state,
        ...action,
    };
};
